import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const GOLD = "#c5a24a";
export const GOLD_DEEP = "#b68e32";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AREA_PRESETS = [
  "Block Valve", "LACT", "Pump Station", "Truck Terminal", "Misc",
  "Compressor Station", "Pipeline", "Metering", "Tank Farm", "Battery",
];

export const PKG_STATUSES = [
  "TBA", "WORKING ON", "CHECKING", "READY TO RETURN", "RETURNED",
  "REQUIRES ATTENTION", "MISSING MODELS", "ON HOLD",
];

export const PKG_STATUS_META = {
  "TBA": "bg-neutral-500/15 text-neutral-300 ring-1 ring-neutral-500/30",
  "WORKING ON": "bg-blue-500/15 text-blue-300 ring-1 ring-blue-500/30",
  "CHECKING": "bg-violet-500/15 text-violet-300 ring-1 ring-violet-500/30",
  "READY TO RETURN": "bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30",
  "RETURNED": "bg-green-500/15 text-green-300 ring-1 ring-green-500/30",
  "REQUIRES ATTENTION": "bg-red-500/15 text-red-300 ring-1 ring-red-500/30",
  "MISSING MODELS": "bg-red-500/15 text-red-300 ring-1 ring-red-500/30",
  "ON HOLD": "bg-neutral-500/15 text-neutral-400 ring-1 ring-neutral-500/30",
};

export const COUNT_FIELDS = [
  { key: "received", label: "Received" },
  { key: "working_on", label: "Working On" },
  { key: "checking", label: "Checking" },
  { key: "completed", label: "Completed" },
  { key: "requires_attention", label: "Attention" },
  { key: "returned", label: "Returned" },
];

export const JOB_STATUS_META = {
  active: { label: "Active", classes: "gold-gradient text-[#121212]" },
  on_hold: { label: "On Hold", classes: "bg-white/10 text-neutral-300" },
  completed: { label: "Completed", classes: "bg-green-600 text-white" },
};

export function computePace(snaps) {
  const s = [...(snaps || [])].sort((a, b) => String(a.week_start || "").localeCompare(String(b.week_start || "")));
  return s.map((x, i) => ({
    week: x.week_key && x.week_key.includes("-W") ? `W${x.week_key.split("-W")[1]}` : x.week_key,
    pace: Math.max((x.completed || 0) - (i > 0 ? (s[i - 1].completed || 0) : 0), 0),
  }));
}

export const IMPORT_FIELDS = [
  { key: "area", label: "Area", hint: "groups drawings" },
  { key: "drawing_number", label: "Drawing #", required: true },
  { key: "title", label: "Title" },
  { key: "description", label: "Description" },
  { key: "rev", label: "Rev" },
  { key: "sheet", label: "Sheet" },
  { key: "discipline", label: "Discipline" },
  { key: "status", label: "Status" },
  { key: "received_date", label: "Received Date" },
  { key: "received", label: "Received (count)" },
  { key: "completed", label: "Completed" },
  { key: "working_on", label: "Working On" },
  { key: "checking", label: "Checking" },
  { key: "requires_attention", label: "Requires Attention" },
  { key: "returned", label: "Returned" },
];
